import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function SponsorWebsiteField({
  value,
  error,
  setValue,
  setError,
  ...rest
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (newValue === '') {
      setError('Website cannot be blank');
    } else if (
      !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/.test(
        String(newValue).toLowerCase()
      )
    ) {
      setError('Website is not a valid URL (must include http(s):// prefix)');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          {...rest}
          label='Website'
          id='web'
          aria-describedby='web-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='web-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='web-helper-text'>
            Enter the sponsor website
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
